import { styled } from "@mui/material";
const FitBox = styled("div", {
  name: "FitBox",
  skipSx: true,
  slot: "FitBox"
})`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;
export {
  FitBox
};
//# sourceMappingURL=FitBox.js.map
